import { render, staticRenderFns } from "./AttendenceTable.vue?vue&type=template&id=31708128&"
import script from "./AttendenceTable.vue?vue&type=script&lang=js&"
export * from "./AttendenceTable.vue?vue&type=script&lang=js&"
import style0 from "./AttendenceTable.vue?vue&type=style&index=0&id=31708128&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports